import React from 'react';
import AuthProvider from './AuthProvider';
import ClientProvider from './ClientProvider';
import QueryProvider from './QueryProvider';
import RadialProvider from './RadialProvider';
import TranslationProvider from './TranslationProvider';
import ToastProvider from './ToastProvider';

const AppProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <AuthProvider>
    <QueryProvider>
      <ClientProvider>
        <RadialProvider>
          <TranslationProvider>
            <ToastProvider>{children}</ToastProvider>
          </TranslationProvider>
        </RadialProvider>
      </ClientProvider>
    </QueryProvider>
  </AuthProvider>
);

export default AppProvider;
